// src/components/Policies/TermsAndConditions.j
import React from 'react';
import styles from './Policies.module.css';
import { Link } from 'react-router-dom';
import { useTheme } from './context/ThemeContext';

const TermsAndConditions = () => {
  const {theme} = useTheme();

  return (
    <div className={`${styles.policyContainer} ${theme === "dark" ? "dark" : ""} ${styles[theme]}`}>
      <div className={styles.policyHeader}>
        <h1 className={styles.title}>Terms & Conditions</h1>
        <p className={styles.effectiveDate}>Effective Date: December 2025</p>
      </div>
  
      <div className={styles.policyContent}>
        <div className={styles.intro}>
          <p>
            These Terms & Conditions, the Privacy Policy, and the Refund & Shipping Policy constitute the entire legal
            agreement between you ("User") and Pixel Moon Store ("we," "us," "our"), operated by GJ Mart. By accessing
            or using the services provided on pixelmoonstore.in, you affirm that you have read, understood, and agreed
            to be bound by these Terms.
          </p>
        </div>
  
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>1. Business Model, Scope of Services, and Compliance</h2>
          <div className={styles.subsection}>
            <h3>1.1 Services Offered</h3>
            <p>
              Pixel Moon Store primarily offers Digital Goods, including esports-related products, game top-ups, in-game
              currency, digital passes, vouchers, and similar virtual items. We may also offer Physical Products
              domestically and internationally.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>1.2 Lawful Use</h3>
            <p>Services are provided strictly for lawful purposes only.</p>
          </div>
          <div className={styles.subsection}>
            <h3>1.3 Prohibition of Restricted Activities</h3>
            <p>
              We strictly do not offer, facilitate, or advertise gambling, online money games, wagering for cash, online
              betting, fantasy sports for cash, casino, poker, rummy, lotteries, or similar prohibited activities.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>1.4 Compliance</h3>
            <p>
              Users must comply with all applicable local, national, and international laws, including age restrictions
              imposed by game publishers and local governments.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>1.5 Minimum Age</h3>
            <p>
              Users must be at least 13 years old or meet the minimum age required by the specific game publishers or
              platform policies, whichever is higher.
            </p>
          </div>
        </section>
  
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>2. Ordering, Payment, and Order Integrity</h2>
          <div className={styles.subsection}>
            <h3>2.1 Order Rejection</h3>
            <p>
              Pixel Moon Store reserves the sole right to reject, refuse, or cancel any order for security, technical,
              fraud prevention, or policy reasons, including errors in pricing or product description.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>2.2 Payments & Compliance</h3>
            <p>All payments are processed through authorized PCI-DSS compliant partners.</p>
          </div>
          <div className={styles.subsection}>
            <h3>2.3 Currency & Authorization</h3>
            <p>
              Prices are listed in Indian Rupees (INR) unless explicitly specified otherwise. Users authorize Pixel Moon
              Store to charge the final amount displayed at checkout.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>2.4 Foreign Transaction Fees</h3>
            <p>
              For payments made in a currency other than INR, the User acknowledges that their bank or payment processor
              may apply additional currency conversion fees and foreign transaction fees, for which Pixel Moon Store is
              not responsible.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>2.5 Pricing Errors</h3>
            <p>
              In the event of a typographical or pricing error, Pixel Moon Store reserves the right to cancel or correct
              the order, even after payment, with a full refund where applicable.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>2.6 No Automatic Subscriptions</h3>
            <p>Users are only charged for one-time purchases. No auto-renewals occur without explicit User consent.</p>
          </div>
        </section>
  
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>3. User Responsibilities and Account Security</h2>
          <div className={styles.subsection}>
            <h3>3.1 Accurate Information</h3>
            <p>
              Users must provide accurate game IDs, platform usernames, email addresses, and shipping details. Pixel
              Moon Store is not responsible for errors or losses caused by incorrect information provided by the User.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>3.2 Account Security</h3>
            <p>
              Users who create accounts are solely responsible for maintaining the confidentiality of their login
              credentials. Users must notify Pixel Moon Store immediately if unauthorized access or a security breach is
              suspected.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>3.3 Right to Refuse Service</h3>
            <p>
              Pixel Moon Store reserves the right to refuse or cancel orders, suspend accounts, or restrict access in
              cases of suspected fraud, abuse, policy violations, or legal non-compliance.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>3.4 Communication Consent</h3>
            <p>
              By using the platform, Users consent to receive necessary transactional emails, order updates, service
              notifications, and policy changes. Email shall be considered a valid and official mode of communication.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>3.5 Explicit Consent</h3>
            <p>
              By using the platform, the User confirms explicit consent to these Terms, Privacy Policy, and Refund
              Policy.
            </p>
          </div>
        </section>
  
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>4. Prohibited Activities and Indemnity</h2>
          <div className={styles.subsection}>
            <h3>4.1 Prohibited Activities</h3>
            <p>
              Users are strictly prohibited from attempting to manipulate, hack, exploit, or abuse the platform, perform
              unjustified chargebacks, misuse APIs, or violate any applicable laws.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>4.2 Fraud, Abuse & Violations</h3>
            <p>
              Any attempts at system manipulation or payment exploitation may result in immediate order cancellation,
              permanent account suspension, reporting to relevant authorities, and pursuit of legal action.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>4.3 Indemnity</h3>
            <p>
              The User agrees to indemnify, defend, and hold harmless Pixel Moon Store (GJ Mart), its affiliates,
              employees, and proprietors from and against any and all claims, losses, liabilities, damages, costs, and
              expenses (including reasonable attorneys' fees) arising from the User's misuse of services or violation of
              these Terms.
            </p>
          </div>
        </section>
  
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>5. Intellectual Property and Disclaimers</h2>
          <div className={styles.subsection}>
            <h3>5.1 Intellectual Property (Our Content)</h3>
            <p>
              All content, branding, logos, images, and materials on the Pixel Moon Store website are the sole property
              of GJ Mart and are protected under intellectual property law.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>5.2 Third-Party Trademarks</h3>
            <p>
              All game names, logos, and trademarks are the property of their respective publishers. Pixel Moon Store is
              an independent platform and is not affiliated with, endorsed by, or sponsored by any game publisher unless
              explicitly stated.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>5.3 Third-Party Services</h3>
            <p>
              Pixel Moon Store is not responsible for service interruptions, delays, errors, bans, rollbacks, or losses
              caused by third-party platforms including game publishers, payment gateways, APIs, or server outages.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>5.4 Disclaimer of Warranties</h3>
            <p>
              Pixel Moon Store and GJ Mart disclaim all warranties, express or implied, including, but not limited to,
              implied warranties of merchantability and fitness for a particular purpose, to the fullest extent
              permitted by law.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>5.5 No Guarantee of Outcomes</h3>
            <p>
              Pixel Moon Store does not guarantee in-game rankings, progression, rewards, availability, or continued
              access to any game content, as such outcomes are controlled solely by game publishers.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>5.6 Limitation of Liability</h3>
            <p>
              Pixel Moon Store and GJ Mart shall not be liable for any indirect, incidental, special, exemplary,
              punitive, or consequential damages arising from the use of the platform or services, to the maximum extent
              permitted under law.
            </p>
          </div>
        </section>
  
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>6. Governing Law and Dispute Resolution</h2>
          <div className={styles.subsection}>
            <h3>6.1 Governing Law & Jurisdiction</h3>
            <p>These Terms are governed by the laws of India, including the Information Technology Act.</p>
          </div>
          <div className={styles.subsection}>
            <h3>6.2 Dispute Resolution & Arbitration</h3>
            <p>
              Any disputes shall first be resolved amicably through good-faith negotiation. If unresolved, disputes
              shall be submitted to binding arbitration in accordance with the Indian Arbitration & Conciliation Act,
              1996.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>6.3 International Users</h3>
            <p>
              While local consumer protection laws may apply where legally required, these Terms are primarily governed
              by Indian law, and the User agrees to the dispute resolution mechanism outlined herein.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>6.4 Changes to Terms & Notification</h3>
            <p>
              Pixel Moon Store reserves the right to modify or update these Terms at any time. Users will be notified of
              significant changes via email and a website banner.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>6.5 Severability</h3>
            <p>
              If any provision of these Terms is deemed invalid, illegal, or unenforceable, the remaining provisions
              shall remain in full force and effect.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>6.6 Force Majeure</h3>
            <p>
              Pixel Moon Store shall not be liable for failure or delay in performance due to events beyond reasonable
              control, including but not limited to natural disasters, government actions, internet outages, platform
              shutdowns, or third-party service failures.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>6.7 Assignment</h3>
            <p>
              Pixel Moon Store may assign or transfer its rights and obligations under these Terms in connection with a
              business transfer, restructuring, or sale.
            </p>
          </div>
        </section>
  
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>7. Entire Agreement</h2>
          <p>
            These Terms, together with the Privacy Policy and Refund & Shipping Policy, constitute the entire agreement
            between the User and Pixel Moon Store.
          </p>
        </section>
  
        <div className={styles.policyLinks}>
          <Link to="/privacy" className={styles.policyLink}>
            Privacy Policy
          </Link>
          <Link to="/refund" className={styles.policyLink}>
            Refund & Shipping Policy
          </Link>
        </div>
      </div>
    </div>
  )
} 
  

export default TermsAndConditions;